import { alpha } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formControlLabel: {
    margin: 0,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:has(.Mui-checked)': {
      backgroundColor: alpha(theme.palette.primary.main, 0.05),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.09),
      },
    },
  },
  radio: {
    '& > .MuiButtonBase-root': {
      width: '16px',
      height: '16px',
    },
  },
}));

export default useStyles;
